module.exports = __webpack_public_path__ + "static/media/kimberly_nguyen.7a36305a.png";